import React from "react"
import JobAnimatedAddress from "../JobAnimatedAddress"

interface IEnRouteProps {
    address: string
    company: string
}

//to be put in job component
const EnRoute: React.FC<IEnRouteProps> = ({ address, company }) => {
    return (
        <>
            <JobAnimatedAddress instruction={"Drive To"} title={address} content={company} positionOffset={"10%"} />
        </>
    )
}

export default EnRoute
